import moment from "moment";
class errors {
  constructor(empId, date, description) {
    this.empId = empId;
    this.date = moment(date).utc().format("DD-MM-YYYY");
    this.description = description;
  }
  static fromJson({ empId, fecha, descripcion }) {
    return new errors(empId, fecha, descripcion);
  }
}
export default errors;
